import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Select as ChakraSelect,
  useToast,
  FormLabel,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useState } from "react";
import Navbar from "../../../Components/Navbar";
import { ChevronRightIcon } from "@chakra-ui/icons";
import AdminSidebar from "../../../Components/AdminSidebar";
import { useNavigate } from "react-router-dom";
import { AiOutlineCamera } from "react-icons/ai";
import {
  IoMdCheckmarkCircleOutline,
  IoMdCloseCircleOutline,
} from "react-icons/io";
import axios from "axios";
import { useSelector } from "react-redux";

const OnBoardingCompany = () => {
  const InputStyle = {
    borderRadius: "md",
    borderWidth: "2px",
    borderColor: "gray.300",
    py: "2",
    px: "4",
    variant: "unstyled",
    // required: true,
  };

  const BoxStyle = {
    position: "absolute",
    top: "-8px",
    left: "8px",
    pointerEvents: "none",
    color: "green",
    fontSize: "sm",
    bg: "white",
    px: "1",
  };

  const [formValues, setFormValues] = useState({});
  const [logo, setLogo] = useState(null);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();
  const adminIdGlobal = useSelector((store) => store.authentication.users.id);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "confirm_password") {
      setPasswordMatch(value === formValues.password);
    }

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExtensions = [".jpeg", ".jpg", ".png"];
    const fileExtension = file.name
      .slice(file.name.lastIndexOf("."))
      .toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      setFileError("Invalid file type. Please select a JPEG or PNG image.");
      setLogo(null);
      return;
    }

    setFileError("");
    setLogo(file);
  };

  const handleFilesUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);

    if (selectedFiles.length > 4) {
      toast({
        position: "top",
        title: "Max 4 Files Allowed",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setFiles(selectedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passwordMatch) {
      toast({
        position: "top",
        title: "Passwords do not match!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("logo", logo);
      files.forEach((file) => formData.append("files", file));

      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }
      formData.append("created_by", adminIdGlobal);
      await axios.post(
        "https://develop-project-360.onrender.com/createCompany",
        formData
      );

      toast({
        position: "top",
        title: "Company Registered Successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setTimeout(() => navigate("/companies"), 3000);
    } catch (error) {
      toast({
        position: "top",
        title: "Error registering company!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <AdminSidebar />
      <Box
        pl={{ base: "none", md: "10" }}
        pt={{ base: "none", md: "10" }}
        w={{ base: "100%", md: "80%" }}
      >
        <Navbar />
        <br />
        <br />
        <Heading size={"md"} textAlign={"start"}>
          Companies
        </Heading>
        <Flex justifyContent={"space-between"}>
          <Breadcrumb
            spacing="8px"
            mt={6}
            mb={6}
            separator={<ChevronRightIcon color="gray.500" />}
          >
            <BreadcrumbItem>
              <BreadcrumbLink href="/admin">Dashboard</BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem>
              <BreadcrumbLink href="/employees">Company</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink href="#">Company Details</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Flex>
        <form onSubmit={handleSubmit}>
          <Box>
            <Flex
              direction={{ base: "column", md: "row" }}
              justifyContent={{ base: "flex-start", md: "space-between" }}
              gap={5}
            >
              <Box
                w={{ base: "100%", md: "50%" }}
                borderRadius={10}
                boxShadow={"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"}
                p={5}
              >
                <Flex justifyContent={"center"}>
                  <Box p={5} borderRadius={10}>
                    <FormControl>
                      <label htmlFor="logo">
                        <Box
                          as="div"
                          display="inline-flex"
                          alignItems="center"
                          justifyContent="center"
                          width="150px"
                          height="150px"
                          borderRadius="full"
                          border="2px dashed"
                          borderColor="gray.300"
                          position="relative"
                          overflow="hidden"
                          cursor="pointer"
                        >
                          {logo ? (
                            <Image
                              src={URL.createObjectURL(logo)}
                              alt="Selected logo"
                              width="100%"
                              height="100%"
                              objectFit="cover"
                            />
                          ) : (
                            <>
                              <AiOutlineCamera size={24} color="gray" />
                              <Box
                                position="absolute"
                                top="50%"
                                left="50%"
                                transform="translate(-50%, -50%)"
                              >
                                <Box as="span" fontSize="sm" color="gray.500">
                                  Click to upload
                                </Box>
                              </Box>
                            </>
                          )}
                          <Input
                            type="file"
                            accept=".jpeg, .jpg, .png"
                            onChange={handleLogoUpload}
                            id="logo"
                            name="logo"
                            position="absolute"
                            opacity="0"
                            width="100%"
                            height="100%"
                            cursor="pointer"
                          />
                        </Box>
                      </label>
                      <FormHelperText color="green">
                        Allowed *.jpeg, *.jpg, *.png
                      </FormHelperText>
                      {fileError && (
                        <Box color="red" fontSize="sm" mt={1}>
                          {fileError}
                        </Box>
                      )}
                    </FormControl>
                  </Box>
                </Flex>
                <Flex
                  direction={{ base: "column", md: "row" }}
                  justifyContent={{ base: "flex-start", md: "space-between" }}
                >
                  <Box w={{ base: "100%", md: "45%" }} p={5} borderRadius={10}>
                    <Box textAlign={"start"}>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="company_name"
                          name="company_name"
                          onChange={handleInputChange}
                          required
                        />
                        <Box {...BoxStyle}>Company Name*</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="email"
                          id="email"
                          name="email"
                          onChange={handleInputChange}
                          required
                        />
                        <Box {...BoxStyle}>Email Address*</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="email"
                          id="alternate_email"
                          name="alternate_email"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>Alternate Email Address</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="address"
                          name="address"
                          onChange={handleInputChange}
                          required
                        />
                        <Box {...BoxStyle}>Address*</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="state"
                          name="state"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>State</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="country"
                          name="country"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>Country</Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box w={{ base: "100%", md: "45%" }} p={5} borderRadius={10}>
                    <Box textAlign={"start"}>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="domain"
                          name="domain"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>Company Domain</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          maxLength={10}
                          id="phone"
                          name="phone"
                          onChange={handleInputChange}
                          required
                        />
                        <Box {...BoxStyle}>Phone*</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          maxLength={10}
                          id="alternate_phone"
                          name="alternate_phone"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>Alternate Phone</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="city"
                          name="city"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>City</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          maxLength={6}
                          id="zip_code"
                          name="zip_code"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>Zip Code</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="employee_id"
                          name="employee_id"
                          onChange={handleInputChange}
                          required
                        />
                        <Box {...BoxStyle}>Company ID*</Box>
                      </Box>
                    </Box>
                  </Box>
                </Flex>
              </Box>
              <Box
                w={{ base: "100%", md: "50%" }}
                borderRadius={10}
                boxShadow={"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"}
                p={5}
              >
                <Flex
                  direction={{ base: "column", md: "row" }}
                  justifyContent={{ base: "flex-start", md: "space-between" }}
                >
                  <Box w={{ base: "100%", md: "45%" }} p={5} borderRadius={10}>
                    <Box textAlign={"start"}>
                      <Box position="relative" mb={5}>
                        <ChakraSelect
                          placeholder=""
                          name="company_type"
                          id="company_type"
                          onChange={handleInputChange}
                          value={formValues.company_type || ""}
                        >
                          <option value=""></option>
                          <option value="Private">Private</option>
                          <option value="LLC">LLC</option>
                          <option value="Startup">Startup</option>
                          <option value="Public">Public</option>
                        </ChakraSelect>
                        <Box {...BoxStyle}>Company Type</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="text"
                          id="aadhar"
                          name="aadhar"
                          maxLength={12}
                          onChange={handleInputChange}
                          required
                        />
                        <Box {...BoxStyle}>Aadhar Number*</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="password"
                          id="password"
                          name="password"
                          onChange={handleInputChange}
                        />
                        <Box {...BoxStyle}>Create Password</Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box w={{ base: "100%", md: "45%" }} p={5} borderRadius={10}>
                    <Box textAlign={"start"}>
                      <Box position="relative" mb={5}>
                        <ChakraSelect
                          placeholder=""
                          name="industry_type"
                          id="industry_type"
                          onChange={handleInputChange}
                          value={formValues.industry_type || ""}
                        >
                          <option value=""></option>
                          <option value="Information Technology">
                            Information Technology
                          </option>
                          <option value="Finance & Accounting">
                            Finance & Accounting
                          </option>
                          <option value="Construction">Construction</option>
                          <option value="Legal">Legal</option>
                          <option value="Manufacturing">Manufacturing</option>
                          <option value="Energy, Oil & Gas">
                            Energy, Oil & Gas
                          </option>
                          <option value="Others">Others</option>
                        </ChakraSelect>
                        <Box {...BoxStyle}>Industry Type</Box>
                      </Box>
                      <Box position="relative" mb={5}>
                        <ChakraSelect
                          placeholder=""
                          name="document_type"
                          id="document_type"
                          onChange={handleInputChange}
                          value={formValues.document_type || ""}
                        >
                          <option value=""></option>
                          <option value="Aadhar Card">Aadhar Card</option>
                          <option value="Voter ID">Voter ID</option>
                          <option value="PAN Card">PAN Card</option>
                          <option value="Others">Others</option>
                        </ChakraSelect>
                        <Box {...BoxStyle}>Document Type</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <InputGroup>
                          <Input
                            {...InputStyle}
                            type="password"
                            id="confirm_password"
                            name="confirm_password"
                            onChange={handleInputChange}
                          />
                          <InputRightElement
                            pointerEvents="none"
                            children={
                              passwordMatch ? (
                                <IoMdCheckmarkCircleOutline color="green" />
                              ) : (
                                <IoMdCloseCircleOutline color="red" />
                              )
                            }
                          />
                        </InputGroup>
                        <Box {...BoxStyle}>Confirm Password</Box>
                      </Box>

                      <Box position="relative" mb={5}>
                        <Input
                          {...InputStyle}
                          type="file"
                          id="files"
                          name="files"
                          onChange={handleFilesUpload}
                          multiple
                          accept=".jpeg, .jpg, .png, .pdf, .docx" // Add allowed file types
                        />
                        <Box {...BoxStyle}>Attach Files</Box>

                        {/* Error message if more than 4 files are selected */}
                        {files.length > 4 && (
                          <Box fontSize="xs" mt="2" color="red">
                            Max 4 files can be selected.
                          </Box>
                        )}

                        {/* Show selected file count only if within the limit */}
                        {files.length > 0 && files.length <= 4 && (
                          <Box fontSize="xs" mt="2" color="green">
                            {files.length} file{files.length > 1 ? "s" : ""}{" "}
                            selected.
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Flex>
                <Flex justifyContent={"flex-end"}>
                  <Button colorScheme="green" size={"sm"} type="submit">
                    On-Board Company
                  </Button>
                </Flex>
              </Box>
            </Flex>
          </Box>
        </form>
      </Box>
    </Flex>
  );
};

export default OnBoardingCompany;
